import React, { useEffect, useState } from 'react';

import Switch from "react-switch";
const MenuCustomization = () => {
  const [customizations, setCustomizations] = useState([]);
  const [filter, setFilter] = useState('');

  const generateEpochTimestamp = () => Math.floor(Date.now() / 1000);

  const generateSignature = (timestamp, token) => {
    const sampleString = String(timestamp);
    const sampleStringBytes = new TextEncoder().encode(sampleString);
    const base64Bytes = btoa(String.fromCharCode.apply(null, sampleStringBytes));
    const tokenNew = token + "-" + base64Bytes;

    const sampleTokenString = String(tokenNew);
    const sampleTokenStringBytes = new TextEncoder().encode(sampleTokenString);
    const base64TokenBytes = btoa(String.fromCharCode.apply(null, sampleTokenStringBytes));
    return base64TokenBytes;
  };

  const fetchSetInStockApi = async (payload) => {
  try {
    const vtimestamp = generateEpochTimestamp();
    const storeInformation = JSON.parse(localStorage.getItem('storeInformation'));
    const authToken = storeInformation.token;
    console.log('payload', JSON.stringify(payload));
    const response = await fetch(
      'https://app.grabbngo.com/product/setcustomizationinstockapi/',
      {
        method: "POST",
        headers: {
          Authorization: `Token ${authToken}`,
          'Content-Type': 'application/json',
          Timestamp: vtimestamp,
          Signature: generateSignature(vtimestamp, authToken)
        },
        body: JSON.stringify(payload),
      }
    );

    if (response.status === 200) {
      console.log("Set success");
      return true;
    } else {
      console.error('Set failed with status', response.status);
      return false;
    }
  } catch (error) {
    console.error('Error Setting data:', error);
    return false;
  }
};

  //  Load data from API
  const fetchJsonData = async () => {
    try {
      const vtimestamp = generateEpochTimestamp();
      const storeInformation = JSON.parse(localStorage.getItem('storeInformation'));
      const authToken = storeInformation.token;
      const storeCode = storeInformation.store.referenceStoreCode;

      const response = await fetch(
        'https://app.grabbngo.com/product/get_store_level_customizations_with_store_code_api/',
        {
          method: "POST",
          headers: {
            Authorization: `Token ${authToken}`,
            'Content-Type': 'application/json',
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)
          },
          body: JSON.stringify({ store_code: String(storeCode) }),
        }
      );

      if (response.status === 200) {
        const data = await response.json();
        const { result } = data;
        const nodes = result.customizations.map(r => r.node);
        setCustomizations(nodes);
      } else {
        console.error('Fetch failed with status', response.status);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };



  useEffect(() => {
    // Toggle between API and file here
    fetchJsonData();
  }, []);

 

const handleSwitchChange = async (checked, id) => {
  const itemToUpdate = customizations.find(
    (item) => item.customization_reference_skucode === id
  );

  if (!itemToUpdate) return;

  const payload = {
    store_code: itemToUpdate.store_code,
    product_skucode: itemToUpdate.product_code,
    customization_skucode: itemToUpdate.customization_skucode,
    customization_refskucode : itemToUpdate.customization_reference_skucode,
    in_stock: checked,
  };

  const success = await fetchSetInStockApi(payload);

  if (success) {
    setCustomizations((prev) =>
      prev.map((item) =>
        item.customization_reference_skucode === id
          ? { ...item, instock: checked }
          : item
      )
    );
  }
};

  const filteredItems = customizations.filter((item) =>
    (item.customization_skucode || '').toLowerCase().includes(filter.toLowerCase()) ||
    (item.customization_name || '').toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div style={{ padding: '20px' }}>
      <h2>Customization Menu</h2>
      <input
        type="text"
        placeholder="Filter by Customization Code or Name..."
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        style={{ marginBottom: '15px', padding: '8px', width: '400px' }}
      />
      <table border="1" cellPadding="10" cellSpacing="0" width="100%">
        <thead>
          <tr>
            <th>Store Code</th>
            <th>Customization SKU Code</th>
            <th>Customization Name</th>
            <th>In Stock</th>
          </tr>
        </thead>
        <tbody>
          {filteredItems.map((item, idx) => (
            <tr key={item.customization_reference_skucode || idx}>
              <td>{item.store_code}</td>
              <td>{item.customization_skucode}</td>
              <td>{item.customization_name}</td>
              <td>
             <Switch
  checked={item.instock}
  id={item.customization_reference_skucode}
  onChange={(checked) =>
    handleSwitchChange(checked, item.customization_reference_skucode)
  }
/>
              </td>
            </tr>
          ))}
          {filteredItems.length === 0 && (
            <tr>
              <td colSpan="5" align="center">No results found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default MenuCustomization;



// WEBPACK FOOTER //
// ./src/pages/InventoryManagement/MenuCustomization.js